import { accountGrid } from '@/shared/grids/accountGrid';
import { companyGrid } from '@/shared/grids/companyGrid';
import { individualGrid } from '@/shared/grids/individualGrid';
import { memberGrid } from '@/shared/grids/memberGrid';
import { recurringTaskGrid } from '@/shared/grids/recurringTaskGrid';
import { serviceGrid } from '@/shared/grids/serviceGrid';
import { smartTaskGrid } from '@/shared/grids/smartTaskGrid';
import { taskGrid } from '@/shared/grids/taskGrid';
import { templateGrid } from '@/shared/grids/templateGrid';
import { GridSettings } from '@/shared/types/grid';
import { ModelName } from '@/shared/types/model';

export const gridSettings: Partial<Record<ModelName, GridSettings<any>>> = {
  AccountView: accountGrid,
  CompanyView: companyGrid,
  IndividualView: individualGrid,
  MemberView: memberGrid,
  RecurringTaskView: recurringTaskGrid,
  ServiceView: serviceGrid,
  SmartTaskView: smartTaskGrid,
  TaskView: taskGrid,
  TemplateView: templateGrid,
};
